import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';

interface IProps {
    year: number;
}
export const useGetDonationInfo = ({ year }: IProps) => {
  const { customerId } = useStore(state => state.user);
  return useQuery(
    'GetDonationInfo',
    async () => {
      const res = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/income?year=${year}`);
      return res.data;
    },
    { enabled: true },
  );
};
